import { JobStageType } from '@shared/generated';

export const JobStageMap = {
  CREATE: JobStageType._1,
  DRAFT: JobStageType._2,
  REVIEW: JobStageType._3,
  INSTALL: JobStageType._4,
  ENROLL: JobStageType._5,
  COMPLETE: JobStageType._6
};
